import { combineReducers, Reducer } from "redux";

import { MutableTypedObject, ReactAction, ReactActionId, TypedObject } from "@multiweb/types/react";
import { DATA_SOURCE_INIT_STATE } from "../initState";
import {
    IDataSourceActions,
    IInitDataSourceAction,
    ISetHasDetailFormAction,
    IUpdateRecordActionsSuccessAction,
} from "../types";

const actions: Reducer<TypedObject<ReactAction>> = (
    state = DATA_SOURCE_INIT_STATE.actions.actions,
    action,
) => {
    if (action instanceof IUpdateRecordActionsSuccessAction) {
        const newActions: MutableTypedObject<ReactAction> = {};
        action.payload.actions.forEach((action) => {
            newActions[action.id] = action;
        });
        return newActions;
    }
    return state;
};

const recordActionsIds: Reducer<ReadonlyArray<ReactActionId>> = (
    state = DATA_SOURCE_INIT_STATE.actions.recordActionsIds,
    action,
) => {
    if (action instanceof IUpdateRecordActionsSuccessAction) {
        return action.payload.actions.map((action) => action.id);
    }
    return state;
};

const hasDetailForm: Reducer<boolean> = (
    state = DATA_SOURCE_INIT_STATE.actions.hasDetailForm,
    action,
) => {
    if (action instanceof IInitDataSourceAction) {
        if (action.payload.hasDetailForm !== undefined) {
            return action.payload.hasDetailForm;
        }
    } else if (action instanceof ISetHasDetailFormAction) {
        return action.payload.hasDetailForm;
    }
    return state;
};

export const actionsReducer: Reducer<IDataSourceActions> = combineReducers({
    actions,
    recordActionsIds,
    hasDetailForm,
});
